const INSIGHTS_ADMIN_EMAIL = "thi@garnishstudios.com";

export const canViewInsights = (email: string | null | undefined): boolean => {
  return email?.trim().toLowerCase() === INSIGHTS_ADMIN_EMAIL;
};
